const url = "/restricoes";
const id = "idenRestricao";

export const initFormRestricao = {
  idenRestricao: null,
  dataRestricao: "",
  tipoRestricao: null,
  descRestricao: "",
  dataSuperacao: "",
  flagSuperacao: null,
  ptaMonitora: null,
  statRestricao: 1,
};

export function salvar(parm) {
  return new Promise(async (resolve, reject) => {
    if (parm[id] && parm[id] !== 0) {
      await atualizar(parm).then((res) => {
        resolve(res);
      });
    } else {
      await criar(parm).then((res) => {
        resolve(res);
      });
    }
  });
}

export function atualizar(parm) {
  return new Promise((resolve, reject) => {
    window.$http.put(`${url}/${parm[id]}`, JSON.stringify(parm)).then((res) => {
      resolve(res.data);
    });
  });
}

export function criar(parm) {
  return new Promise((resolve, reject) => {
    window.$http.post(`${url}/${parm.ptaMonitora.idenPtaMonitora}`, JSON.stringify(parm)).then((res) => {
      resolve(res.data);
    });
  });
}

export function excluir(idenRestricao) {
  return new Promise((resolve, reject) => {
    window.$http.delete(`${url}/${idenRestricao}`).then((res) => {
      resolve(res);
    });
  });
}

export function buscarTiposRestricoes() {
  return new Promise((resolve, reject) => {
    window.$http.get(`tiporestricoes/buscarAtivos`).then((res) => {
      resolve(res.data);
    });
  });
}
